import React, { useState } from "react";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";
import LinkDuo from "components/LinkDuo";
import { EmptyCard } from "components/Shared/EmptyCard";
import HistoryCards from "components/Homeowner/CaseDetails/HistoryCards";
import webConfig from "middlewares/WebConfig";

const RemarksCards = ({ remark }) => {
    return (
        <div className="details-notes">
            {remark ?
                <Card className="md-block-centered">
                    <CardContent>
                        <TextField field={remark} />
                    </CardContent>
                </Card>
                : EmptyCard()}
        </div>
    );
};
RemarksCards.propTypes = {
    remark: PropTypes.string
};

function CaseHistoryTabWrapper(props) {
    const caseHistory = props.caseHistory;
    const [tabValue, setTabValue] = useState(0);
    return (
        <Box>
            <Tabs value={tabValue} onChange={(e, newValue) => setTabValue(newValue)}>
                <Tab label="All" />
                <Tab label="Touches" />
                <Tab label="CS Notes" />
                <Tab label="Call Log" />
                <Tab label="Case Issues" />
            </Tabs>
            {tabValue === 0 && <Box p={2}><HistoryCards notes={caseHistory.allNotes} /></Box>}
            {tabValue === 1 && <Box p={2}><HistoryCards notes={caseHistory.touches} /></Box>}
            {tabValue === 2 && <Box p={2}><HistoryCards notes={caseHistory.csNotes} /></Box>}
            {tabValue === 3 && <Box p={2}><HistoryCards notes={caseHistory.callLog} /></Box>}
            {tabValue === 4 && <Box p={2}><HistoryCards notes={caseHistory.issues} /></Box>}
        </Box>
    );
}

CaseHistoryTabWrapper.propTypes = {
    caseHistory: PropTypes.object.isRequired
};

function CaseRemarksTabWrapper(props) {
    const caseRemarks = props.caseRemarks;
    const [tabValue, setTabValue] = useState(0);
    return (
        <Box>
            <Tabs value={tabValue} onChange={(e, newValue) => setTabValue(newValue)}>
                <Tab label="Survey Remarks" />
                <Tab label="Private Notes" />
                <Tab label="Close Out Notes" />
                <Tab label="Appointment Directions" />
            </Tabs>
            {tabValue === 0 && <Box p={2}><RemarksCards remark={caseRemarks.surveyRemarks} /></Box>}
            {tabValue === 1 && <Box p={2}><RemarksCards remark={caseRemarks.privateNotes} /></Box>}
            {tabValue === 2 && <Box p={2}><RemarksCards remark={caseRemarks.closeOutNotes} /></Box>}
            {tabValue === 3 && <Box p={2}><RemarksCards remark={caseRemarks.appointmentDirections} /></Box>}
        </Box>
    );
}

CaseRemarksTabWrapper.propTypes = {
    caseRemarks: PropTypes.object.isRequired
};

const CaseNotesHeader = ({ menuItems, switchMenuItem, controlNumber, token }) => {
    return (
        <div className="details-notes-header">
            <div className="md-grid">
                <TextField
                    id="selectButtonLinks"
                    select
                    variant="standard"
                    defaultValue={menuItems[0].id}
                    onChange={(e) => switchMenuItem(e.target.value)}
                    className="md-cell"
                >
                    {menuItems.map(item => (
                        <MenuItem key={item.id} value={item.id}>{item.desc}</MenuItem>
                    ))}
                </TextField>
                <div className="details-case-button">
                    <LinkDuo
                        to={`${webConfig.caseUrlTemplate}${controlNumber}`}
                        token={token}>
                        <Button
                            endIcon={<Icon>navigate_next</Icon>}>
                            Go To Case
                        </Button>
                    </LinkDuo>
                </div>
            </div>
        </div>
    );
};
CaseNotesHeader.propTypes = {
    menuItems: PropTypes.array.isRequired,
    switchMenuItem: PropTypes.func.isRequired,
    controlNumber: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired
};

export {
    CaseNotesHeader,
    CaseHistoryTabWrapper,
    CaseRemarksTabWrapper
};